import { add, differenceInDays, format } from "date-fns";
import { cloneDeep } from "lodash";
import React, { useCallback, useEffect, useMemo, useState } from "react";
import { Tab } from "react-bootstrap";
import toast from "react-hot-toast";
import { defineMessages, FormattedMessage, useIntl } from "react-intl";
import { withAuthorizationVerifier } from "../../components/authorization-verifier";
import { SectionHeading, SectionSubHeading } from "../../components/section-heading";
import { useUserProfile } from "../../components/user-profile-provider";
import { useConfig } from "../../lib/config";
import { DATE_SELECTION_TYPE, EXTRA_TYPE } from "../witadmin/Common/constants";
import { CurrencyExchangeTotal, Deposit, OriginalTotal } from "./components/CardTotal";
import { FooterButtons } from "./components/FooterButtons";
import { FormAccommodations } from "./components/FormAccommodations";
import { FormQuotationData } from "./components/FormQuotationData";
import { BasicInput } from "./components/Inputs";

import { ModalAccomodations, ModalConfirmation, ModalExtras } from "./components/Modals";
import { SectionPax } from "./components/SectionPax";
import { PROPERTY_ARI_STATUS_OCCUPATION_CODE } from "./constants";

import {
  MainContainer,
  StyledCloseButton,
  StyledContainerTab,
  StyledModalEmailLabelInput,
  StyledModalEmailSubtitle,
  StyledModalEmailTitle,
  StyledModalTextInvalidCode,
  StyledPlusTab,
  StyledSpanTitleTab,
  StyledTabs,
  StyledWrapperInput,
} from "./styled";

import {
  calculateDeposit,
  changeConditions,
  changeEstablishmentValue,
  changeMealPlanInventory,
  changeRoomInventory,
  changeValue,
  createSharedBooking,
  functionGetAccommodationsByPropertyAri,
  functionGetNewValuesAccomodation,
  generateTab,
  getDataBodyPropertyAri,
  getDataPropertyARI,
  getEmailBody,
  handleAddTab,
  handleConfirmExtra,
  handleDeleteConfirm,
  sendEmail,
  validatePromoCode,
  validateSearchData,
} from "./utils";
import { useHttpClient } from "../../lib/http";

const messages = defineMessages({
  desktop: {
    id: "quotation.desktop",
    defaultMessage: "Desktop",
  },
  mobile: {
    id: "quotation.mobile",
    defaultMessage: "Mobile",
  },
  tablet: {
    id: "quotation.tablet",
    defaultMessage: "Tablet",
  },
  quotationTitle: {
    id: "quotation.title",
    defaultMessage: "Reservas",
  },
  quotationSubtitle: {
    id: "quotation.subtitle",
    defaultMessage: "Cotización de grupo",
  },
  quotationModalConfirmationBody: {
    id: "quotation.modalConfirmation.body",
    defaultMessage: "Se eliminarán la selección de alojamientos, pensión y condición.",
  },
  quotationContinue: {
    id: "quotation.continue",
    defaultMessage: "¿Continuar?",
  },
  quotationModalConfirmationBodyDelete: {
    id: "quotation.modalConfirmation.bodyDelete",
    defaultMessage: "La cotización será eliminada",
  },
  quotationSegure: {
    id: "quotation.segure",
    defaultMessage: "¿Está seguro?",
  },
  quotationInvalidatePromocode: {
    id: "quotation.invalidatePromocode",
    defaultMessage: "Promocode no válido",
  },
  quotationModalConfirmationTickerBody: {
    id: "quotation.modalConfirmationTicker.body",
    defaultMessage: "Se eliminarán la selección de alojamientos, pensión y condición.",
  },
  quotationOk: {
    id: "quotation.ok",
    defaultMessage: "Ok",
  },
  quotationYes: {
    id: "quotation.yes",
    defaultMessage: "Sí",
  },
  quotationBack: {
    id: "quotation.back",
    defaultMessage: "Volver",
  },
  emailSuccess: {
    id: "quotation.emailSuccess",
    defaultMessage: "emailSuccess",
  },
  emailFailure: {
    id: "quotation.emailFailure",
    defaultMessage: "emailFailure",
  },
});

function Quotation() {
  const userProfile = useUserProfile();

  const [calcAccomodation, setCalcAccomodation] = useState(false);

  const [modalAccommodation, setModalAccommodation] = useState(false);
  const [modalExtras, setModalExtras] = useState(false);
  const [modalSendEmail, setModalSendEmail] = useState(false);

  const [modalConditions, setModalConditions] = useState(false);
  const [modalPromoCode, setModalPromoCode] = useState(false);
  const [modalConfirmation, setModalConfirmation] = useState(false);
  const [modalConfirmationTicker, setModalConfirmationTicker] = useState(false);

  //TODO ADD TYPEs
  const [tempValueTicker, setTempValueTicker] = useState<any>({});
  const [tempValueCondition, setTempValueCondition] = useState<any>({});

  const [dataPropertyAri, setDataPropertyAri] = useState<any>({});
  const [dataExtrasRoom, setDataExtrasRoom] = useState<any>([]);

  const [total, setTotal] = useState<any>(0);
  const [deposit, setDeposit] = useState<any>(0);

  const [tabs, setTabs] = useState<any>([]);
  const [actualTab, setActualTab] = useState<string>();
  const [actualRoom, setActualRoom] = useState(0);

  const [dataInventories, setDataInventories] = useState<any>([]);
  const [dataInventoriesRelations, setDataInventoriesRelations] = useState<any>([]);
  const [establishmentNameList, setEstablishmentNameList] = useState<any>({});

  const [backOfficeLang, setBackOfficeLang] = useState("");

  const intl = useIntl();
  const config = useConfig();
  const apiClient = useHttpClient(config.apiEndpoint);

  const [emailSubject, setEmailSubject] = useState("");
  const [firstEmail, setFirstEmail] = useState("");
  const [secondEmail, setSecondEmail] = useState("");

  const listOfDevice = useCallback(() => {
    return [
      { value: "DESKTOP", label: intl.formatMessage(messages.desktop) },
      { value: "MOBILE", label: intl.formatMessage(messages.mobile) },
      { value: "TABLET", label: intl.formatMessage(messages.tablet) },
    ];
  }, [intl]);

  const myPropertyARI = useCallback(
    async (indexRoom: number, device: string = "") => {
      let actTab = tabs.findIndex((tab: any) => tab.id === actualTab);
      actTab = actTab > -1 ? actTab : 0;
      const accommodation = tabs[actTab].accommodations[indexRoom];

      const dataBody = getDataBodyPropertyAri(tabs[actTab], accommodation, device);

      const { data: dataPropertyARI } = await getDataPropertyARI(
        `${config.apiEndpoint}/api/property/${tabs[actTab].establishment.value}/es/propertyARI`,
        dataBody
      );

      return dataPropertyARI;
    },
    [actualTab, config.apiEndpoint, tabs]
  );

  const handleSendEmail = useCallback(async () => {
    let actTab = tabs.findIndex((tab: any) => tab.id === actualTab);
    actTab = actTab > -1 ? actTab : 0;
    const tab = tabs[actTab];

    const emailBody = getEmailBody(tab, firstEmail, secondEmail, emailSubject);

    sendEmail(config.apiEndpoint, tabs[actTab].establishment.value, emailBody, tab.lang.value)
      .then(function () {
        toast.success(intl.formatMessage(messages.emailSuccess));
      })
      .catch(function () {
        toast.error(intl.formatMessage(messages.emailFailure));
      });
  }, [actualTab, config.apiEndpoint, tabs, emailSubject, firstEmail, secondEmail]);

  useEffect(() => {
    if (modalSendEmail) {
      const indexTab = tabs.findIndex((tab: any) => tab.id === actualTab);
      const tab = tabs[indexTab];
      const valueSubject = `${establishmentNameList[tab.establishment?.value]} / ${format(
        new Date(tab.checkIn),
        "dd-MM-yyyy"
      )} - ${format(new Date(tab.checkOut), "dd-MM-yyyy")} / ${tab.condition.label}`;
      setEmailSubject(valueSubject);
    }
  }, [actualTab, modalSendEmail, tabs]);

  const searchAccommodations = useCallback(
    async (indexRoom: number) => {
      const indexTab = tabs.findIndex((tab: any) => tab.id === actualTab);
      if (validateSearchData(tabs[indexTab > -1 ? indexTab : 0], indexRoom)) {
        const resMyPropertyAri = await myPropertyARI(indexRoom);
        setDataPropertyAri(resMyPropertyAri);
        setActualRoom(indexRoom);
      }
    },
    [actualTab, myPropertyARI, tabs]
  );

  const handleDeleteAccommodations = (indexRoom: number) => {
    let indexTab = tabs.findIndex((tab: any) => tab.id === actualTab);
    indexTab = indexTab > -1 ? indexTab : 0;
    const newTabs = [...tabs];
    newTabs[indexTab].accommodations.splice(indexRoom, 1);
    setTabs([...newTabs]);
  };

  const handleSelectRoom = useCallback(
    (newInventorySelected: any) => {
      const indexTab = tabs.findIndex((tab: any) => tab.id === actualTab);
      tabs[indexTab].accommodations[actualRoom] = {
        ...tabs[indexTab].accommodations[actualRoom],
        ...newInventorySelected,
        extraValue: 0,
      };

      const dataExtras: any[] = [];

      newInventorySelected?.services?.forEach((tickerExtra: string) => {
        let itemExtra =
          dataPropertyAri[tabs[indexTab]?.establishment?.value]?.services[tickerExtra];
        const ariValue =
          dataPropertyAri[tabs[indexTab]?.establishment?.value]?.arivalues[tickerExtra];
        if (ariValue) {
          itemExtra = { ...itemExtra, ariValue };
        }
        if (itemExtra) {
          const list: any = [];
          if (itemExtra.obligatory && itemExtra.dateSelectionType === DATE_SELECTION_TYPE.ALL) {
            const startReservation = new Date(tabs[indexTab].checkIn);
            const endReservation = new Date(tabs[indexTab].checkOut);
            const diffDates = differenceInDays(endReservation, startReservation);

            for (let index = 0; index < diffDates; index++) {
              list.push({
                day: format(add(startReservation, { days: index }), "EEEEEE dd MMM"),
                value: {
                  value: itemExtra.totalRate,
                  label: itemExtra.totalRate,
                },
              });
            }
          }
          dataExtras.push({ ...itemExtra, selected: false, list });
        }
      });
      setDataExtrasRoom([...dataExtras]);

      tabs[indexTab].accommodations[actualRoom].extraSelected = [...dataExtras];

      setTabs([...tabs]);
      setModalAccommodation(false);
    },
    [actualRoom, actualTab, dataPropertyAri, tabs]
  );

  const handleShowExtras = useCallback(
    (indexRoom: number) => {
      setActualRoom(indexRoom);
      const indexTab = tabs.findIndex((tab: any) => tab.id === actualTab);
      const dataExtras: any[] = [];
      const extraSelected = tabs[indexTab].accommodations[indexRoom]?.extraSelected;
      if (extraSelected) {
        setDataExtrasRoom([...extraSelected]);
      } else {
        tabs?.[indexTab]?.accommodations?.[indexRoom]?.services?.forEach((tickerExtra: string) => {
          let itemExtra =
            dataPropertyAri[tabs[indexTab]?.establishment?.value]?.services[tickerExtra];
          const ariValue =
            dataPropertyAri[tabs[indexTab]?.establishment?.value]?.arivalues[tickerExtra];
          if (ariValue) {
            itemExtra = { ...itemExtra, ariValue };
          }
          if (itemExtra) {
            const startReservation = new Date(tabs[indexTab].checkIn);
            const endReservation = new Date(tabs[indexTab].checkOut);
            const diffDates = differenceInDays(endReservation, startReservation);

            const list: any = [];
            if (
              itemExtra.type === EXTRA_TYPE.ROOM &&
              itemExtra.dateSelectionType === DATE_SELECTION_TYPE.NONE
            ) {
              for (let index = 0; index < diffDates; index++) {
                list.push({
                  day: format(add(startReservation, { days: index }), "EEEEEE dd MMM"),
                  value: {
                    value: tabs?.[indexTab]?.accommodations[actualRoom]?.rooms?.value || 1,
                    label: tabs?.[indexTab]?.accommodations[actualRoom]?.rooms?.value || 1,
                  },
                });
              }

              dataExtras.push({ ...itemExtra, selected: false, list });
            }
          }
        });
        setDataExtrasRoom([...dataExtras]);
      }
      setModalExtras(true);
    },
    [actualTab, dataPropertyAri, tabs]
  );

  const getRatioCurrency = useCallback(() => {
    const indexTab = tabs.findIndex((tab: any) => tab.id === actualTab);
    if (tabs?.[indexTab]?.configurations?.currencyExchange) {
      if (
        tabs?.[indexTab]?.configurations?.currencyExchange?.currencyBase ===
        tabs?.[indexTab]?.currency?.value
      ) {
        return 1;
      } else {
        return tabs[indexTab].configurations.currencyExchange.prices[tabs[indexTab].currency.value];
      }
    } else {
      return 0;
    }
  }, [actualTab, tabs]);

  const validateInventory = useCallback(
    (prices: any, ticker: any, accommodations: any) => {
      let discount = 0;
      accommodations.forEach((accommodation: any) => {
        const parent = dataInventoriesRelations?.parents[ticker];
        const s = dataInventoriesRelations?.children?.[parent]?.some(
          (element: any) => element === accommodation?.mealPlan?.prices?.ticker
        );
        if (s) {
          discount += accommodation.rooms.value;
        }
      });
      return {
        ...prices,
        originalAvailability: prices.availability,
        availability: prices.availability - discount,
      };
    },
    [dataInventoriesRelations?.children, dataInventoriesRelations?.parents]
  );

  const getAccommodationValue = useCallback(
    indexRoom => {
      const indexTab = tabs.findIndex((tab: any) => tab.id === actualTab);
      const inventory = tabs?.[indexTab]?.accommodations?.[indexRoom];
      return (
        (inventory?.mealPlan?.prices?.totalRate * inventory?.rooms?.value || 0) * getRatioCurrency()
      );
    },
    [actualTab, getRatioCurrency, tabs]
  );

  const getExtraValue = useCallback(
    indexRoom => {
      const indexTab = tabs.findIndex((tab: any) => tab.id === actualTab);
      const inventory = tabs?.[indexTab]?.accommodations?.[indexRoom];
      const extrasValue =
        inventory?.extraValue ||
        tabs?.[indexTab]?.accommodations?.[indexRoom]?.mealPlan?.prices?.obligatoryExtrasValue;
      return extrasValue * getRatioCurrency() || 0;
    },
    [actualTab, getRatioCurrency, tabs]
  );

  const handleOkConditions = useCallback(
    (selectedOption?: any) => {
      const indexTab = tabs.findIndex((tab: any) => tab.id === actualTab);
      const tab = tabs[indexTab];
      changeConditions(tab, selectedOption ? selectedOption : tempValueCondition, tabs, setTabs);
      setModalConditions(false);
    },
    [actualTab, tabs, tempValueCondition]
  );

  const handleAlertConditions = (selectedOption: any) => {
    const indexTab = tabs.findIndex((tab: any) => tab.id === actualTab);
    const tab = tabs[indexTab];
    setTempValueCondition(selectedOption);
    if (tab?.condition?.value && tab.accommodations?.[0]?.rooms?.value >= 0) {
      setModalConditions(true);
    } else {
      handleOkConditions(selectedOption);
    }
  };

  const addEstablishmentName = useCallback(
    nameObj => {
      setEstablishmentNameList({ ...establishmentNameList, ...nameObj });
    },
    [setEstablishmentNameList, establishmentNameList]
  );

  const handleOkEstablishment = async (selectedOption?: any) => {
    const indexTab = tabs.findIndex((tab: any) => tab.id === actualTab);
    const tab = tabs[indexTab];

    const dataConfiguration = await apiClient.get<any>(
      `/api/property/${selectedOption ? selectedOption.value : tempValueTicker.value}/configuration`
    );

    changeEstablishmentValue(
      tab,
      selectedOption ? selectedOption : tempValueTicker,
      tabs,
      setTabs,
      config.apiEndpoint,
      backOfficeLang,
      setModalPromoCode,
      setDataInventoriesRelations,
      addEstablishmentName,
      dataConfiguration
    );

    setModalConfirmationTicker(false);
  };

  const handleConfirmChangeEstablishment = (selectedOption: any) => {
    const indexTab = tabs.findIndex((tab: any) => tab.id === actualTab);
    const tab = tabs[indexTab];
    setTempValueTicker(selectedOption);

    if (tab?.establishment?.value) {
      setModalConfirmationTicker(true);
    } else {
      handleOkEstablishment(selectedOption);
    }
  };

  const getAccommodationsByPropertyAri = useCallback(() => {
    return functionGetAccommodationsByPropertyAri(
      actualTab,
      tabs,
      dataPropertyAri,
      validateInventory,
      actualRoom
    );
  }, [actualTab, tabs, dataPropertyAri, validateInventory, actualRoom]);

  const getNewValuesAccomodation = useCallback(() => {
    functionGetNewValuesAccomodation(
      tabs,
      setTabs,
      actualTab,
      validateInventory,
      myPropertyARI,
      actualRoom
    );
  }, [tabs, actualTab, validateInventory, myPropertyARI, actualRoom]);

  useEffect(
    function changeLang() {
      if (intl.locale.includes("es")) {
        setBackOfficeLang("es");
      } else if (intl.locale.includes("en")) {
        setBackOfficeLang("en");
      }
    },
    [intl]
  );

  useEffect(
    function updateValuesAccommodation() {
      getNewValuesAccomodation();
      // eslint-disable-next-line react-hooks/exhaustive-deps
    },
    [calcAccomodation]
  );

  useEffect(
    function calcTotalsByActualTab() {
      const indexTab = tabs.findIndex((tab: any) => tab.id === actualTab);
      const tab = tabs[indexTab];
      let total: number = 0;
      let totalDeposit: number = 0;
      (tab?.accommodations || []).forEach((_element: any, indexRoom: number) => {
        const totalRate = getAccommodationValue(indexRoom) + getExtraValue(indexRoom);

        total += totalRate;

        const condition =
          dataPropertyAri[tabs[indexTab]?.establishment?.value]?.conditions[tab.condition.value];

        const deposit =
          calculateDeposit({
            condition,
            dataPropertyAri,
            tabs,
            tab,
            totalRate,
            indexTab,
            indexRoom,
          }) || 0;

        totalDeposit += deposit;
      });
      setDeposit(totalDeposit.toFixed(2));
      setTotal(total.toFixed(2));
      setTempValueCondition(tab?.condition);
      setTempValueTicker(tab?.establishment);
    },
    [actualTab, getAccommodationValue, getExtraValue, tabs]
  );

  useEffect(
    function loadFirstTab() {
      const newTabs = [generateTab(userProfile?.email || "", intl.formatMessage(messages.desktop))];
      console.log("newTabs", newTabs);
      setTabs(newTabs);
      setActualTab(newTabs[0].id);
    },
    [intl, userProfile]
  );

  useEffect(
    function loadInventories() {
      const dataInventories = getAccommodationsByPropertyAri();
      dataInventories?.forEach(inventory => {
        inventory.mealplans.sort((a: any, b: any) =>
          a.prices.totalRate > b.prices.totalRate ? 1 : -1
        );
      });
      const indexTab = tabs.findIndex((tab: any) => tab.id === actualTab);
      const tab = tabs[indexTab];

      dataInventories?.forEach(inventory => {
        if (tab?.accommodations?.[actualRoom]?.ticker === inventory.ticker) {
          inventory.mealPlan = tab.accommodations[actualRoom].mealPlan;
          inventory.mealplan = tab.accommodations[actualRoom].mealplan;
          inventory.rooms = tab.accommodations[actualRoom].rooms;
        } else {
          inventory.mealPlan = inventory.mealplans[0];
          inventory.mealplan = inventory.mealplans[0].value;
          inventory.rooms = { value: 1, label: "1 Habitación" };
        }
      });
      setDataInventories(dataInventories);
    },
    [actualRoom, actualTab, getAccommodationsByPropertyAri, tabs]
  );

  const handleChangeValue = useCallback(
    async (key, value, index) => {
      const tab = tabs[index];
      await changeValue({
        tab,
        key,
        value,
        calcAccomodation,
        setCalcAccomodation,
        tabs,
        setTabs,
      });
    },
    [calcAccomodation, setCalcAccomodation, tabs, setTabs, changeValue]
  );

  const accommodationsSet = useMemo(
    () => tabs.some((tab: any) => tab.accommodations.some((acc: any) => acc.ticker)),
    [tabs]
  );

  const showAlternativeOccupation = useMemo(() => {
    const establishment = tabs.find((tab: any) => tab.id === actualTab)?.establishment?.value;

    return (
      dataPropertyAri[establishment]?.status?.OCCUPATION?.code ===
      PROPERTY_ARI_STATUS_OCCUPATION_CODE.IGNORED_FILTER
    );
  }, [dataPropertyAri, tabs]);

  const setOccupations = useCallback(
    occupations => {
      const tabIndex = tabs.findIndex((tab: any) => tab.id === actualTab);
      if (tabIndex === -1) {
        throw new Error("unable to find tab");
      }
      const accommodation = tabs[tabIndex].accommodations[actualRoom];
      const newAccommodation = { ...accommodation, ...occupations };

      const tabsClone = cloneDeep(tabs);

      tabsClone[tabIndex].accommodations[actualRoom] = newAccommodation;

      setTabs(tabsClone);
    },
    [tabs, actualTab, actualRoom]
  );

  return (
    <MainContainer odd={true} resultsMsg={"ok"}>
      <SectionHeading>
        <FormattedMessage {...messages.quotationTitle} />
      </SectionHeading>
      <SectionSubHeading>
        <FormattedMessage {...messages.quotationSubtitle} />
      </SectionSubHeading>

      <ModalConfirmation
        showModal={modalConditions}
        onHideModal={() => setModalConditions(false)}
        handleOk={() => handleOkConditions()}
        handleCancel={() => setModalConditions(false)}
        textBody={
          <div style={{ textAlign: "center", fontSize: "15px", fontWeight: 600, color: "#FF6136" }}>
            <FormattedMessage {...messages.quotationModalConfirmationBody} />
            <FormattedMessage {...messages.quotationContinue} />
          </div>
        }
      />

      <ModalConfirmation
        showModal={modalConfirmation}
        onHideModal={() => setModalConfirmation(false)}
        handleOk={() =>
          handleDeleteConfirm(actualTab, tabs, setActualTab, setTabs, setModalConfirmation)
        }
        handleCancel={() => setModalConfirmation(false)}
        textBody={
          <div style={{ textAlign: "center", fontSize: "15px", fontWeight: 600, color: "#FF6136" }}>
            <FormattedMessage {...messages.quotationModalConfirmationBodyDelete} />
            <FormattedMessage {...messages.quotationSegure} />
          </div>
        }
      />

      <ModalConfirmation
        showModal={modalSendEmail}
        onHideModal={() => setModalSendEmail(false)}
        handleOk={() => {
          handleSendEmail();
          setModalSendEmail(false);
        }}
        handleCancel={() => setModalSendEmail(false)}
        ModalConfirmation={"Cancelar"}
        txtOk={"Enviar"}
        txtCancel={"Cancelar"}
        size={"lg"}
        textBody={
          <div style={{ padding: "60px", textAlign: "center" }}>
            <StyledModalEmailTitle>Enviar cotización</StyledModalEmailTitle>
            <StyledWrapperInput>
              <StyledModalEmailLabelInput>Asunto:</StyledModalEmailLabelInput>
              <BasicInput
                id={"emailSubject"}
                label={""}
                value={emailSubject}
                onChange={setEmailSubject}
              />
            </StyledWrapperInput>

            <hr />
            <StyledModalEmailSubtitle>
              La cotización se enviará a los siguientes destinatarios:
            </StyledModalEmailSubtitle>
            <StyledWrapperInput>
              <StyledModalEmailLabelInput>{`Email 1:`}</StyledModalEmailLabelInput>
              <BasicInput
                id={"firstEmail"}
                label={""}
                value={firstEmail}
                onChange={setFirstEmail}
              />
            </StyledWrapperInput>
            <StyledWrapperInput>
              <StyledModalEmailLabelInput>Email 2:</StyledModalEmailLabelInput>
              <BasicInput
                id={"secondEmail"}
                label={""}
                value={secondEmail}
                onChange={setSecondEmail}
              />
            </StyledWrapperInput>
          </div>
        }
      />

      <ModalConfirmation
        showModal={modalPromoCode}
        onHideModal={() => setModalPromoCode(false)}
        handleOk={() => setModalPromoCode(false)}
        handleCancel={() => setModalPromoCode(false)}
        textBody={
          <StyledModalTextInvalidCode>
            <FormattedMessage {...messages.quotationInvalidatePromocode} />
          </StyledModalTextInvalidCode>
        }
        twoButtons={false}
        txtOk={intl.formatMessage(messages.quotationOk)}
      />

      <ModalConfirmation
        showModal={modalConfirmationTicker}
        onHideModal={() => {
          setModalConfirmationTicker(false);
        }}
        handleOk={() => {
          handleOkEstablishment();
          setModalConfirmationTicker(false);
        }}
        handleCancel={() => setModalConfirmationTicker(false)}
        textBody={
          <div style={{ textAlign: "center", fontSize: "15px", fontWeight: 600, color: "#FF6136" }}>
            <FormattedMessage {...messages.quotationModalConfirmationTickerBody} />
            <FormattedMessage {...messages.quotationContinue} />
          </div>
        }
        txtOk={intl.formatMessage(messages.quotationYes)}
        txtCancel={intl.formatMessage(messages.quotationBack)}
      />
      {modalAccommodation && dataInventories && (
        <ModalAccomodations
          actualRoom={actualRoom}
          tabs={tabs}
          actualTab={actualTab}
          showModal={modalAccommodation}
          onHideModal={() => setModalAccommodation(false)}
          dataInventories={dataInventories}
          ratioCurrency={getRatioCurrency()}
          changeMealPlanInventory={(indexInventory: any, mealPlan: any) =>
            changeMealPlanInventory(indexInventory, mealPlan, dataInventories, setDataInventories)
          }
          changeRoomInventory={(indexInventory: any, selectedOption: any) =>
            changeRoomInventory(
              indexInventory,
              selectedOption,
              dataInventories,
              setDataInventories,
              tabs,
              setTabs,
              actualTab,
              actualRoom
            )
          }
          handleSelectRoom={(inventory: any) => handleSelectRoom(inventory)}
          showAlternativeOccupation={showAlternativeOccupation}
          setOccupations={setOccupations}
        />
      )}

      <ModalExtras
        dataExtraRoom={dataExtrasRoom}
        setDataExtrasRoom={setDataExtrasRoom}
        showModal={modalExtras}
        onHideModal={() => setModalExtras(false)}
        tabs={tabs}
        actualTab={actualTab}
        handleConfirm={() =>
          handleConfirmExtra(tabs, actualTab, actualRoom, dataExtrasRoom, setTabs, setModalExtras)
        }
        ratioCurrency={getRatioCurrency()}
      />

      <StyledContainerTab>
        <StyledTabs
          defaultActiveKey={tabs && tabs[0]?.id}
          activeKey={actualTab}
          onSelect={(id: string | null) => setActualTab(id ?? undefined)}>
          {tabs.map((tab: any, index: number) => {
            return (
              <Tab
                key={tab.id}
                eventKey={tab.id}
                title={
                  <>
                    <StyledSpanTitleTab>
                      {" "}
                      {tab.title} {index + 1}{" "}
                    </StyledSpanTitleTab>{" "}
                    {tabs.length > 1 && (
                      <StyledCloseButton onClick={() => setModalConfirmation(true)} />
                    )}
                  </>
                }>
                <FormQuotationData
                  handleConfirmChangeEstablishment={(selectedOption: any) => {
                    handleConfirmChangeEstablishment(selectedOption);
                  }}
                  tab={tab}
                  changeValue={(key: string, value: any) => {
                    handleChangeValue(key, value, index);
                  }}
                  changeConditions={(selectedOption: any) => {
                    handleAlertConditions(selectedOption);
                  }}
                  validatePromoCode={() =>
                    validatePromoCode(tabs, actualTab, setTabs, config.apiEndpoint)
                  }
                  listOfDevice={listOfDevice()}
                />
                <FormAccommodations
                  tab={tab}
                  changeValue={(key: string, selectedOption: any, indexRoom: any) =>
                    changeValue({
                      tab,
                      key,
                      value: selectedOption,
                      indexRoom,
                      calcAccomodation,
                      setCalcAccomodation,
                      tabs,
                      setTabs,
                    })
                  }
                  searchAccommodations={(indexRoom: number) => searchAccommodations(indexRoom)}
                  setModalAccommodation={() => {
                    setModalAccommodation(true);
                  }}
                  getAccommodationValue={(indexRoom: any) => getAccommodationValue(indexRoom)}
                  getExtraValue={(indexRoom: number) => getExtraValue(indexRoom)}
                  setModalExtras={(indexRoom: number) => handleShowExtras(indexRoom)}
                  handleDeleteAccommodations={(indexRoom: any) =>
                    handleDeleteAccommodations(indexRoom)
                  }
                />
                <SectionPax tab={tab} />
                <OriginalTotal tab={tab} total={total} ratio={getRatioCurrency()} />
                <Deposit tab={tab} total={total} deposit={deposit} />
                <CurrencyExchangeTotal tab={tab} total={total} />
                <FooterButtons
                  accommodationsSet={accommodationsSet}
                  tabs={tabs}
                  dataInventories={dataInventories}
                  handleAddTab={() =>
                    handleAddTab(
                      true,
                      setTabs,
                      tabs,
                      actualTab,
                      userProfile,
                      intl.formatMessage(messages.desktop)
                    )
                  }
                  handleDeleteTab={() => setModalConfirmation(true)}
                  actualTab={actualTab}
                  setModalSendEmail={setModalSendEmail}
                  handleReservation={() =>
                    createSharedBooking({
                      tabs,
                      actualTab,
                      prefixURL: config.engineBaseUrl,
                      engineApiEndpoint: config.engineApiEndpoint,
                    })
                  }
                />
              </Tab>
            );
          })}
          <Tab
            key={-1}
            title={
              <StyledPlusTab
                onClick={() =>
                  handleAddTab(
                    false,
                    setTabs,
                    tabs,
                    actualTab,
                    userProfile,
                    intl.formatMessage(messages.desktop)
                  )
                }>
                {"+"}
              </StyledPlusTab>
            }></Tab>
        </StyledTabs>
      </StyledContainerTab>
    </MainContainer>
  );
}

export default withAuthorizationVerifier(Quotation);
